import React from "react";
import MenuItem from "@mui/material/MenuItem";

import { useSnackbar } from "components/haven-design/snackbar";
import { useInterestsTable } from "../interests-table/table-context";
import { getOwnerBulkValidationError, OwnerBulkAction } from "../owner-bulk";

type Props = {
  action: OwnerBulkAction;
  closeMenu: () => void;
  setModalOpen: (open: boolean) => void;
};

// Mirrors AddNoteButton: a single MenuItem in the bulk-actions menu that opens
// the bulk Assign-/Remove-Owner modal. Validation is shared with the owner-cell pencil.
const OwnerActionButton: React.FC<Props> = ({ action, closeMenu, setModalOpen }) => {
  const { openSnackbar } = useSnackbar();
  const table = useInterestsTable();
  const { totalSelectedInterests } = table;

  const isAssign = action === "assign";
  const label = isAssign ? "Assign Owner" : "Remove Owner";
  const menuId = isAssign ? "actions-assign-owner" : "actions-remove-owner";

  const showError = (message: string) => {
    setTimeout(() => openSnackbar({ message, status: "error", duration: 5000 }), 100);
  };

  const open = () => {
    const error = getOwnerBulkValidationError(action, table);
    if (error) showError(error);
    else setModalOpen(true);
    closeMenu();
  };

  return (
    <MenuItem id={menuId} onMouseUp={open}>
      {label} {`(${totalSelectedInterests})`}
    </MenuItem>
  );
};

export default OwnerActionButton;
